import { render, staticRenderFns } from "./CardTabelaVisaoGeral.vue?vue&type=template&id=608fd993&"
import script from "./CardTabelaVisaoGeral.vue?vue&type=script&lang=js&"
export * from "./CardTabelaVisaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports